var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8379 12.1569C41.8379 10.4952 40.4911 9.15341 38.8356 9.15341C37.18 9.15341 35.832 10.4952 35.832 12.1569C35.832 13.8125 37.18 15.1543 38.8356 15.1543C40.4911 15.1543 41.8379 13.8125 41.8379 12.1569",
    fill: "url(#paint0_linear_10332_15111)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.847 35.6009C45.7358 38.0386 45.3281 39.3631 44.9896 40.2427C44.5349 41.4091 43.9925 42.243 43.1129 43.1178C42.243 43.9925 41.4091 44.5337 40.2427 44.9834C39.3631 45.3269 38.0336 45.7358 35.596 45.852C32.9607 45.9681 32.1798 45.9928 25.4969 45.9928C18.8202 45.9928 18.0331 45.9681 15.3978 45.852C12.9602 45.7358 11.6369 45.3269 10.7572 44.9834C9.58472 44.5337 8.75696 43.9925 7.88222 43.1178C7.00127 42.243 6.45891 41.4091 6.01042 40.2427C5.67183 39.3631 5.25799 38.0386 5.15291 35.6009C5.02448 32.9656 5.00094 32.1724 5.00094 25.5031C5.00094 18.8202 5.02448 18.0331 5.15291 15.3978C5.25799 12.9602 5.67183 11.6369 6.01042 10.7498C6.45891 9.58473 7.00127 8.75567 7.88222 7.88092C8.75696 7.00748 9.58472 6.46503 10.7572 6.01042C11.6369 5.66571 12.9602 5.2629 15.3978 5.1468C18.0331 5.0306 18.8202 5.00094 25.4969 5.00094C32.1798 5.00094 32.9607 5.0306 35.596 5.1468C38.0336 5.2629 39.3631 5.66571 40.2427 6.01042C41.4091 6.46503 42.243 7.00748 43.1129 7.88092C43.9925 8.75567 44.5349 9.58473 44.9896 10.7498C45.3281 11.6369 45.7358 12.9602 45.847 15.3978C45.9693 18.0331 45.999 18.8202 45.999 25.5031C45.999 32.1724 45.9693 32.9656 45.847 35.6009V35.6009ZM50.348 15.1927C50.2257 12.5289 49.8056 10.709 49.1817 9.12391C48.5466 7.47941 47.6953 6.08575 46.3017 4.6921C44.9142 3.30465 43.5206 2.45335 41.8761 1.81091C40.2848 1.19312 38.471 0.768076 35.806 0.651969C33.141 0.523444 32.2898 0.499999 25.4969 0.499999C18.7102 0.499999 17.8528 0.523444 15.1878 0.651969C12.5289 0.768076 10.7164 1.19312 9.1177 1.81091C7.47941 2.45335 6.08575 3.30465 4.6983 4.6921C3.30464 6.08575 2.45335 7.47941 1.81211 9.12391C1.19433 10.709 0.774284 12.5289 0.64576 15.1927C0.529652 17.8577 0.5 18.7102 0.5 25.5031C0.5 32.2898 0.529652 33.141 0.64576 35.806C0.774284 38.4649 1.19433 40.2835 1.81211 41.8761C2.45335 43.5144 3.30464 44.9142 4.6983 46.3017C6.08575 47.6891 7.47941 48.5467 9.1177 49.1879C10.7164 49.8056 12.5289 50.2257 15.1878 50.348C17.8528 50.4703 18.7102 50.5 25.4969 50.5C32.2898 50.5 33.141 50.4703 35.806 50.348C38.471 50.2257 40.2848 49.8056 41.8761 49.1879C43.5206 48.5467 44.9142 47.6891 46.3017 46.3017C47.6953 44.9142 48.5466 43.5144 49.1817 41.8761C49.8056 40.2835 50.2257 38.4649 50.348 35.806C50.4703 33.141 50.5 32.2898 50.5 25.5031C50.5 18.7102 50.4703 17.8577 50.348 15.1927V15.1927Z",
    fill: "url(#paint1_linear_10332_15111)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5012 33.8307C20.9014 33.8307 17.1689 30.1044 17.1689 25.5046C17.1689 20.8973 20.9014 17.1661 25.5012 17.1661C30.1023 17.1661 33.8397 20.8973 33.8397 25.5046C33.8397 30.1044 30.1023 33.8307 25.5012 33.8307V33.8307ZM25.5012 12.659C18.4106 12.659 12.668 18.4139 12.668 25.5046C12.668 32.589 18.4106 38.3379 25.5012 38.3379C32.5918 38.3379 38.3407 32.589 38.3407 25.5046C38.3407 18.4139 32.5918 12.659 25.5012 12.659Z",
    fill: "url(#paint2_linear_10332_15111)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10332_15111",
    x1: 0.942456,
    y1: 49.9841,
    x2: 46.327,
    y2: 4.59976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10332_15111",
    x1: 0.950993,
    y1: 50.0453,
    x2: 46.3728,
    y2: 4.62353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10332_15111",
    x1: 0.967084,
    y1: 50.0481,
    x2: 46.3779,
    y2: 4.6372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501119,
    stopColor: "#F50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950079,
    stopColor: "#B900B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.be306e4a25c1b0d2a58432ad8406344d.svg";
export { ForwardRef as ReactComponent };